import { combineReducers } from 'redux';

import list from './list';
import form from './form';
import currentSceneId from './currentSceneId';
import autoSave from './autoSave';

export default combineReducers({
  list,
  form,
  currentSceneId,
  autoSave,
});
